<template>
  <Modal v-model="open" :title="title" width="800">
    <div class="photo-manager">
      <div class="photo-list">
        <div v-for="(photo, index) in photos" :key="index" class="photo-item">
          <img :src="img + photo" alt="照片" class="photo-preview" />
          <div class="photo-actions">
            <Upload
              ref="photoUpload"
              :before-upload="(file) => handlePhotoUpload(file, index)"
              action
              :max-size="2048"
              accept="image/*"
              :show-upload-list="false"
            >
              <Button type="primary" size="small">更换</Button>
            </Upload>
            <Button type="error" size="small" @click="removePhoto(index)">删除</Button>
          </div>
        </div>
        <div class="add-photo">
          <Upload
            ref="addPhotoUpload"
            :before-upload="handlePhotoUpload"
            action
            :max-size="2048"
            accept="image/*"
            :show-upload-list="false"
          >
            <Button type="primary">添加照片</Button>
          </Upload>
        </div>
      </div>
    </div>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel">关闭</Button>
      <Button type="primary" :loading="loading" @click="save">保存</Button>
    </div>
  </Modal>
</template>

<script>
import { editArea } from '@/api/area'
import { imgUpload } from '@/api/upload'

export default {
  name: 'PhotoManager',
  data() {
    return {
      open: false,
      img: process.env.VUE_APP_BASEURL,
      title: '照片管理',
      loading: false,
      photos: [],
      areaId: null
    }
  },
  methods: {
    init(params) {
      this.areaId = params.area_id
      this.getPhotos()
      this.open = true
    },

    getPhotos() {
      // 从区域数据中获取照片列表
      const area = JSON.parse(this.$store.state.areas).find(a => a.area_id == this.areaId)
      if (area) {
        this.photos = area.photos || []
      }
    },

    handlePhotoUpload(file, index) {
      const formData = new FormData()
      formData.append('avatar', file)
      return new Promise((resolve, reject) => {
        imgUpload(formData)
          .then(res => {
            if (res.data.code === 200) {
              if (typeof index === 'number') {
                // 更新现有照片
                this.photos[index] = res.data.imgUrl
              } else {
                // 添加新照片
                this.photos.push(res.data.imgUrl)
              }
              this.$Message.success('上传成功')
              resolve(false)
            } else {
              this.$Message.error(res.data.msg)
              reject()
            }
          })
          .catch(err => {
            this.$Message.error(err)
            reject()
          })
      })
    },

    removePhoto(index) {
      this.photos.splice(index, 1)
    },

    save() {
      this.loading = true
      const areas = JSON.parse(this.$store.state.areas)
      const area = areas.find(a => a.area_id == this.areaId)
      if (!area) {
        this.$Message.error('未找到区域数据')
        this.loading = false
        return
      }

      editArea({
        area_id: area.area_id,
        photos: this.photos
      })
        .then(res => {
          if (res.data.code === 200) {
            this.$Message.success('保存成功')
            // 更新store中的区域数据
            const index = areas.findIndex(a => a.area_id == this.areaId)
            if (index !== -1) {
              areas[index].photos = this.photos
              this.$store.commit('setareas', JSON.stringify(areas))
              console.log(this.$store.state.areas,123123)
            }
            this.cancel()
            this.$emit('reload')
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$Message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },

    cancel() {
      this.open = false
      this.photos = []
      this.areaId = null
    }
  }
}
</script>

<style lang="less" scoped>
.photo-manager {
  .photo-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding: 16px;

    .photo-item {
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 8px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .photo-preview {
        width: 100%;
        height: 150px;
        object-fit: cover;
        border-radius: 4px;
      }

      .photo-actions {
        display: flex;
        gap: 8px;
        justify-content: center;
      }
    }

    .add-photo {
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 150px;
      cursor: pointer;

      &:hover {
        border-color: #2d8cf0;
      }
    }
  }
}
</style> 